import React from "react";

const CalendorIcon = ({
  fill = "#71717A",
  width = "14px",
  height = "14px",
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33333 1.16663V3.49996M4.66667 1.16663V3.49996M1.75 5.83329H12.25M2.91667 2.33329H11.0833C11.7277 2.33329 12.25 2.85563 12.25 3.49996V11.6666C12.25 12.311 11.7277 12.8333 11.0833 12.8333H2.91667C2.27233 12.8333 1.75 12.311 1.75 11.6666V3.49996C1.75 2.85563 2.27233 2.33329 2.91667 2.33329Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CalendorIcon;
